import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import moment from "moment";
import Firebase from "../../firebasehelper";
import Header from "../../components/Header";
import ScheduleModal from "./ScheduleModal";
import { saveUsers, saveBrand } from "../../redux/actions";
import { alertAppointment } from "../../functions/Twilio";
import { getDayStr } from "../../functions/index";
import "./index.css";
import { TerritoryOptions } from "../../Constants/retailer";
const calendar_png = require("../../assets/media/calendar-hub/calendar.png");
const user_avatar = require("../../assets/media/profile/avatar.png");

function formatAMPM(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
}

export const Placeholder = () => {
  return (
    <div className="col-div placeholder-view">
      <img src={calendar_png} width="70" />
      <p>You have no active tasks or appointments for today.</p>
    </div>
  );
};
export const UserItem = ({ data, performAt }) => {
  const { duration, user, title } = data;
  let time = performAt.toDate();
  return (
    <div className="user_item">
      <p>{formatAMPM(time)}</p>
      <p>{duration}min</p>
      <p>{title}</p>
      <p>{user.firstname}</p>
      <div
        className="avatar"
        style={{ backgroundImage: `url(${user.avatar_url || user_avatar})` }}
      />
    </div>
  );
};
export const MyCalendarView = ({ onClickDay, bgColor, white }) => {
  const [selectedWeek, setWeek] = useState(0);
  const [selectedDay, setDay] = useState(null);
  const [date, setDate] = useState(null);
  useEffect(() => {
    let startday = 0;
    [0, 1, 2, 3, 4, 5, 6].forEach((item) => {
      if (moment().isSame(getWeekDate(item), "date")) startday = item;
    });
    setDay(startday);
    setDate(moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }));
  }, []);
  useEffect(() => {
    if (selectedDay === null) onClickDay(null);
    else onClickDay(date);
  }, [selectedDay]);
  const showDays = () => {
    const weekDays = moment.weekdaysShort();
    return [0, 1, 2, 3, 4, 5, 6].map((item, index) => {
      const date = getWeekDate(index);
      if (date.isSameOrAfter(moment(), "day"))
        return (
          <button
            key={index}
            style={{
              width: "13%",
              backgroundColor: selectedDay === item ? bgColor : "transparent",
              color:
                selectedDay === item ? (white ? "white" : "black") : "black",
            }}
            className={`btn day-btn`}
            onClick={() => {
              setDate(date);
              setDay(item);
            }}
          >
            {weekDays[date.get("day")]} {date.format("DD[th] MMM")}
          </button>
        );
      // return <p key={index} style={{ width: "13%" }}></p>;
    });
  };
  const getWeekDate = (i) => {
    if (moment().isSame(moment().startOf("week"))) {
      return moment().add("days", selectedWeek * 7 + i - 6);
    }
    return moment()
      .startOf("week")
      .add("days", selectedWeek * 7 + i + 1);
  };
  return (
    <Fragment>
      <div className="week-bar">
        <p style={{ fontWeight: 700 }}>My Calendar</p>
        {[0, 1, 2, 3, 4].map((obj) => (
          <button
            key={obj}
            style={{
              backgroundColor: selectedWeek === obj ? bgColor : "transparent",
              color:
                selectedWeek === obj ? (white ? "white" : "black") : "black",
            }}
            className={`btn week_btn`}
            onClick={() => {
              setDay(null);
              setWeek(obj);
            }}
          >
            Week {obj + 1}
          </button>
        ))}
      </div>
      <div className="calendar">
        <div className="date">{showDays()}</div>
      </div>
    </Fragment>
  );
};

class CalendarHub extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      communityMembers: [],
      loading: false,
      date: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
      tasks: [],
    };
  }

  componentDidMount() {
    if (!this.props.location.state) this.props.history.push("/");
    else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, (res) => {
        this.loadState(res);
        this.props.dispatch(saveBrand(res));
        this.loadUser(res.name);
      });
    }
  }
  loadState = async (brand_data) => {
    this.setState({
      logo: brand_data.logo,
      icon: brand_data.icon,
      brand_name: brand_data.name,
      brand_url: brand_data.url,
      territory: brand_data.territory || TerritoryOptions[0],
      hex: brand_data.hex,
      white: brand_data.white,
      is_property_brand: brand_data.is_property_brand
        ? brand_data.is_property_brand
        : false,
      loading: false,
    });
    Firebase.getAllTasksRunningByBrand(brand_data.name, (res) => {
      this.setState({ tasks: res });
    });
  };
  loadUser = async (brand) => {
    this.setState({ loading: true });
    let users = await Firebase.getAllUsersInBrand(brand);
    let userPromise = users.map(async (user) => {
      const { eco_id } = user;
      let eco_data = {};
      if (eco_id) eco_data = await Firebase.getEcoUserbyId(eco_id);
      return { ...user, ...eco_data };
    });
    Promise.all(userPromise).then((res) => {
      this.props.dispatch(saveUsers(res));
      let sorted = res.sort((a, b) => {
        if (b.phonenumber) return 1;
        else if (a.phonenumber) return -1;
      });
      this.setState({ communityMembers: sorted, loading: false });
    });
  };

  schedule = async (option) => {
    const { date, brand_name: brand } = this.state;
    const { description, duration, time, title, user } = option;
    const { hh, mm } = time;
    const minutes = hh * 60 + mm;
    const scheduled_time = moment(date).add(minutes, "minutes");
    let task = {
      brand,
      options: { user, title, description, duration },
      performAt: scheduled_time.toDate(),
      status: "scheduled",
      worker: "makeCall",
    };
    try {
      await Firebase.addTask(task);
      console.log("new task is added", task);
      const { firstname, phonenumber } = user;
      if (phonenumber)
        alertAppointment(
          phonenumber,
          brand,
          firstname,
          getDayStr(scheduled_time.toDate())
        );
    } catch (error) {
      console.log("error", error);
    }
  };
  setDay = (date) => {
    this.setState({ date });
  };
  getTasksScheduledInDay(tasks, starting_date) {
    const end_date = starting_date.clone().add(1, "day");

    let res = [];
    res = tasks.filter((task) => {
      const { performAt, status } = task;
      if (
        moment(performAt.toDate()).isBetween(starting_date, end_date) &&
        status === "scheduled"
      )
        return true;
      else return false;
    });
    return res;
  }

  render() {
    const {
      username,
      role,
      logo,
      brand,
      loading,
      brand_name,
      communityMembers,
      hex,
      white,
      date,
      tasks,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          brand={brand}
          brandName={brand_name}
        />
        <main id="main-container" className="calendar-content">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            </div>
          )}
          {!loading && (
            <MyCalendarView
              onClickDay={this.setDay}
              bgColor={hex}
              white={white}
            />
          )}
          <div className="user-list">
            {!loading &&
              date &&
              this.getTasksScheduledInDay(tasks, date).map((task) => {
                return (
                  <UserItem
                    data={task.options}
                    performAt={task.performAt}
                  ></UserItem>
                );
              })}
            {!loading &&
              date &&
              this.getTasksScheduledInDay(tasks, date).length === 0 && (
                <Placeholder />
              )}
          </div>
          {!loading && (
            <div className="row-div" style={{ marginTop: 50 }}>
              <button
                className="btn btn-green"
                disabled={!date}
                data-toggle="modal"
                data-target="#schedule-meeting"
                style={{ margin: 5 }}
              >
                Add a new appointment
              </button>
              <button
                className="btn btn-brand-hex btn-white"
                style={{
                  margin: 5,
                  "--hover-color": hex ? hex : "black",
                  "--hover-text-color": white ? "white" : "black",
                }}
              >
                Add my schedule availability
              </button>
            </div>
          )}
          {!loading && (
            <ScheduleModal
              users={communityMembers}
              isDatePickable={false}
              schedule={this.schedule}
            />
          )}
        </main>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    uid: state.uid,
    users: state.users,
    brand: state.brand,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CalendarHub);



// WEBPACK FOOTER //
// ./src/screens/CalendarHub/index.js